import React from "react";
import {Box, Card, CardContent, Table, TableBody, TableCell, TableRow, Typography} from "@mui/material";

function MandantRolle({roles}) {
    return (
        <div>
            <Box m="0 0 1em 1em">
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Zugewiesene Rollen in Keycloak
                        </Typography>
                        <Table size="small">
                            <TableBody>
                                {roles.map(function (role) {
                                    return <TableRow key={role.id}>
                                        <TableCell>{role.name}</TableCell>
                                    </TableRow>
                                })}
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}

export default MandantRolle;